export class MeetingListUserStatusComponent {
    isOnline!: boolean;

    get tooltipText() {
        return this.isOnline ? 'Active' : 'Away';
    }
}

angular.module('tradersyard').component('tyMeetingListUserStatus', {
    // language=HTML
    template: `
            <div class="meeting_list_user_status" ng-class="{'is-online': $ctrl.isOnline}" uib-tooltip="{{$ctrl.tooltipText}}"></div>
        `,
    bindings: {
        isOnline: '<',
    },
    controller: MeetingListUserStatusComponent,
});
